import { InjectionToken } from '@angular/core';

export interface IAppConfig {
  apiUrl: string;
  authUrl: string;
  hasHttps: boolean;
  webAppUrl: string;
  appUrl: string;
  recaptchaSiteKey?: string;
  isE2e: boolean;
}

export interface CommonEnvironment {
  angularProdMode: boolean;
  /*
   * Do not use name based checks in code
   * bad code exmaple:
   * if (environmentName === 'development') {...}
   * good code expample
   * if (environment.isSomeFeatureEnabled) {...}
   * or for more complex scenarios
   * const { isEnabled, key, timeout, apiUrl, isDebug } = environment.someFeature
   * if (isEnabled && key && timeout > 10 && apiUrl && isDebug) {...}
   */
  environmentName: 'production' | 'staging' | 'development' | 'rc' | 'development-stg';
  trackDuplicateHttpRequests?: boolean;
  /*
   * Generic flag to enable any kind of debug features that may be implemented in app
   **/
  rtDebugEnabled?: boolean;
}

export const APP_CONFIG = new InjectionToken('App config');
export const AUTH_TOKEN = new InjectionToken<string>('AUTH_TOKEN');
export const COMPANY_ID = new InjectionToken<number | null>('COMPANY_ID');
export const AUTH_METHOD = new InjectionToken<string>('AUTH_METHOD');
export const ADMIN = new InjectionToken<any>('ADMIN');
export const ENVIRONMENT = new InjectionToken<CommonEnvironment>('App environment');
export const PATH_WHITELIST = new InjectionToken<string[] | null>('White list of paths');
